import { SystemErrors } from "../definitions/systemErrors";
import AuditTrail from "../models/AuditTrail";
import ApiService from "./ApiService";
import Utils from "../utils/Utils";

export default class AuditTrailService {
  public static async getList(): Promise<AuditTrail[]> {
    return new Promise((resolve, reject) => {
      ApiService.get("/audittrail/getList", "")
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }
  public static async getByDateRange(fromDate: Date, toDate: Date): Promise<AuditTrail[]> {
    return new Promise((resolve, reject) => {
      ApiService.post("/audittrail/getListByDateRange", { startDate: fromDate, endDate: toDate })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static async getAuditTrailListByType(recordTypeId: any): Promise<AuditTrail[]> {
    return new Promise((resolve, reject) => {
      let url = `/audittrail/payrun/${recordTypeId}`;
      ApiService.get(url, "")
        .then((result) => {
          if (!result.data || result.data.statusCode != SystemErrors.Authentication.Success || !result.data.value) {
            resolve([] as AuditTrail[]);
          } else {
            const retVal = this.getAudiTrailDetail(result.data.value);
            resolve(retVal);
          }
        })
        .catch((error) => reject("error => " + error));
    });
  }

  public static async getAuditTrailListByTypeAdmin(recordTypeId: any, teamMemberId: any): Promise<AuditTrail[]> {
    return new Promise((resolve, reject) => {
      // set default record type id
      if (!recordTypeId) {
        recordTypeId = "-1";
      }
      let url = `/audittrail/payrun/admin/${recordTypeId}/${teamMemberId}`;
      ApiService.get(url, "")
        .then((result) => {
          if (!result.data || result.data.statusCode != SystemErrors.Authentication.Success || !result.data.value) {
            resolve([] as AuditTrail[]);
          } else {
            const retVal = this.getAudiTrailDetail(result.data.value);
            resolve(retVal);
          }
        })
        .catch((error) => reject("error => " + error));
    });
  }

  public static async set(model: AuditTrail): Promise<AuditTrail> {
    return new Promise((resolve, reject) => {
      ApiService.post("/audittrail", model)
        .then((result) => {
          resolve(model);
        })
        .catch((error) => reject(error));
    });
  }

  public static async setForAdmin(model: AuditTrail): Promise<AuditTrail> {
    return new Promise((resolve, reject) => {
      ApiService.post("/audittrail/admin", model)
        .then((result) => {
          resolve(model);
        })
        .catch((error) => reject(error));
    });
  }

  private static getAudiTrailDetail(list: any): AuditTrail[] {
    const auditTrails = [] as AuditTrail[];
    list.map((d: any) => {
      var auditTrail = { id: d.id, ...d } as AuditTrail;
      if (auditTrail.DateTime) {
        auditTrail.DateTime = Utils.vsDateToDatetime(d.DateTime);
      }
      auditTrails.push(auditTrail);
    });
    return auditTrails;
  }
}
